// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class BrokerMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_TEXT_MESSAGE, fieldSet);
    }
    setText(text) {
        this.setFieldValue(FieldsFactory.FIELD_TEXT, text);
    }
    setType(type) {
        this.setFieldValue(FieldsFactory.FIELD_TEXT_MESSGE_TYPE, type);
    }
    setSenderId(id) {
        this.setFieldValue(FieldsFactory.FIELD_SENDER_ID, id);
    }
    setTargetId(id) {
        this.setFieldValue(FieldsFactory.FIELD_TARGET_ID, id);
    }
    setDate(date) {
        this.setFieldValue(FieldsFactory.FIELD_DATE, date);
    }
    setName(name) {
        this.setFieldValue(FieldsFactory.FIELD_NAME, name);
    }
    setId(id) {
        this.setFieldValue(FieldsFactory.FIELD_ID, id);
    }
}
